import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { FolderLibraryItemFragmentDoc } from '../../library/all/FoldersGrid.generated';
export type LibraryItemFoldersDetailCard_LibraryItemFragment = { __typename?: 'LibraryItem', id: string, parentFolderMemberships: Array<{ __typename?: 'LibraryItemFolderMembership', id: string, folder?: { __typename?: 'Folder', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, folder?: { __typename?: 'Folder', id: string, position: string } | null } } | null }> };

export const LibraryItemFoldersDetailCard_LibraryItemFragmentDoc = gql`
    fragment LibraryItemFoldersDetailCard_LibraryItem on LibraryItem {
  id
  parentFolderMemberships {
    id
    folder {
      id
      libraryItem {
        ...FolderLibraryItem
      }
    }
  }
}
    ${FolderLibraryItemFragmentDoc}`;